import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of, Subject } from 'rxjs';
import { UserService } from '@services/user.service';
import { mergeMap, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RolePermissionsGuard implements CanActivate {

  constructor(private userService: UserService, private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean|UrlTree> | Promise<boolean> | boolean {
    let req_role:any[];
    console.log("ROUTING")
    console.log(route)
    if (route.data && route.data.permission) {
      req_role = route.data.permission
    } else {
      return of(true)
    }
    //If types are specified in the route data config,
    //check to see if the current rout uses that type before to see if a permission check is needed
    if (route.data.rest_type) {
      console.log("has restricted types", route.data.rest_type)
      //temp container of permissions
      let restTypes = [];
      //req_role is an array of permission flags from the role
      req_role.forEach(role => {
        //rest_type is an object containing arrays. The key for each array is the permission, the array contains data types pertaining to that role
        if (!route.params.type || !route.data.rest_type[role].includes(route.params.type)) {
          console.log("Doesn't include type", route.params.type)
        } else {
          //if the current data type is in the required type list for this permission, it needs to be checked add it to the temp permission list
          restTypes.push(role)
        }
      })
      //if there are items in temp permisison list, update to required permissions so only the needed permissions are checked
      //if no permissions need to be check completye the route
      if (restTypes.length === 0) {
        console.log("Doesn't include type", route.params.type)
        return of(true);
      } else {
        req_role = restTypes;
      }
      console.log("includes type", route.params.type)
    }
    let sub: Subject<boolean|UrlTree> = new Subject();
    this.userService.getRoleDetails(true).pipe(take(1)).subscribe(
      (roledetails) => {
        console.log(roledetails);
        let hasRoles = false;
        //check each required permission to see if the user has it
        req_role.forEach(role => {
          if (roledetails[role]) {
            hasRoles = true;
          } else {
            hasRoles = false;
            return false;
          }
        })
        //
        if (hasRoles) {
          console.log("Complete route")
          sub.next(true);
          sub.complete()
        } else {
          console.log("Reject route")
          sub.next(this.router.parseUrl('/home'));
          sub.complete()
        }
      }
    )

    return sub;
  }

}
